import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { FormProps } from './Form.types'

const Form = <
  TFormValues extends Record<string, unknown> = Record<string, unknown>
>({
  children,
  onSubmit,
  useFormProps,
  validationSchema,
  defaultValues,
  ...rest
}: FormProps<TFormValues>) => {
  const methods = useForm<TFormValues>({
    ...(!!validationSchema && { resolver: yupResolver(validationSchema) }),
    ...(!!useFormProps && useFormProps),
    ...(!!defaultValues && { defaultValues }),
  })

  return (
    <form {...rest} onSubmit={methods.handleSubmit(onSubmit)}>
      {children(methods)}
    </form>
  )
}

export { Form }
